import { use_slice_workspace, use_slice_workspace_billing } from '@/hooks/store/use_slices';
import { use_workspace_balance } from '@/hooks/use_workspace_balance';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export function USViewCreditsBalance() {
  const { balances_map } = use_slice_workspace_billing(['balances_map']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const workspace_balance = use_workspace_balance();

  return (
    <div>
      {t(i18n_page_settings_workspace.tabs.credits.general_component.credits)}: {workspace_balance}
    </div>
  );
}
